import { c as _c } from "react/compiler-runtime";
import { CommissionNextGenIcon, CommissionSecondTierIcon, ExclamationIcon, NotificationIcon, RefundIcon, TimeIcon } from '@systemeio/ui/icons';
import { FormSelect, Tooltip, cents, centsToUnits } from '@systemeio/ui';
import { useAffiliateDashboardPayments } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-payments';
import { AffiliateDashboardFilterInterface, AffiliateDashboardFilterWithTagInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardPaymentsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-payments-interface';
import { AffiliateCommissionTypeEnum } from 'modules/affiliate-program/affiliate/enums/affiliate-commission-type-enum';
import React, { useEffect, useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { currencyFormat } from 'shared/utils/currency-format';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip';
interface AffiliateDashboardPaymentsProps {
  mainFilter: AffiliateDashboardFilterInterface;
  defaultFilter: AffiliateDashboardFilterInterface;
  tagsData: SelectorDataInterface<TagId>[] | undefined;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardPayments = t0 => {
  const $ = _c(75);
  const {
    mainFilter,
    tagsData,
    defaultFilter,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    clearPagination
  } = usePagination(true);
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== defaultFilter) {
    t1 = {
      ...defaultFilter,
      affiliateTag: undefined
    };
    $[0] = defaultFilter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [filterWithTag, setFilterWithTag] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== mainFilter) {
    t2 = () => {
      setFilterWithTag(prev => ({
        ...prev,
        ...mainFilter
      }));
    };
    t3 = [mainFilter];
    $[2] = mainFilter;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== filterWithTag || $[6] !== limit || $[7] !== pagination) {
    t4 = {
      filter: filterWithTag,
      pagination,
      limit
    };
    $[5] = filterWithTag;
    $[6] = limit;
    $[7] = pagination;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    affiliatePayments,
    counter
  } = useAffiliateDashboardPayments(t4);
  let t5;
  if ($[9] !== clearPagination) {
    t5 = tagId => {
      setFilterWithTag(prev_0 => ({
        ...prev_0,
        affiliateTag: tagId
      }));
      clearPagination();
    };
    $[9] = clearPagination;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const changeTag = t5;
  let t6;
  if ($[11] !== clearPagination) {
    t6 = () => {
      clearPagination();
    };
    $[11] = clearPagination;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== clearPagination || $[14] !== mainFilter) {
    t7 = [mainFilter, clearPagination];
    $[13] = clearPagination;
    $[14] = mainFilter;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== t) {
    t8 = t("dashboard.affiliate_dashboard.vendor_product");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== setMainFilter || $[19] !== t) {
    t9 = payment => <div className="flex w-full items-center justify-between gap-3 truncate"><div className="flex w-full items-center gap-3 truncate"><button onClick={() => setMainFilter(prev_1 => ({
          ...prev_1,
          vendorId: payment.payment.user.id
        }))} className="ring-brand-primary h-[32px] w-[32px] shrink-0 rounded-full outline-hidden ring-offset-2 focus-visible:ring-2"><img alt={payment.payment.user.affiliateProgramBrandName} className="h-[32px] w-[32px] rounded-full" src={payment.payment.user.avatar} /></button><div className={`flex w-full flex-col truncate ${payment.isFirstPayment && "text-text-primary font-bold"}`}><div className="flex w-full gap-1 truncate">{payment.payment.user.affiliateProgramBrandName && <><span className="max-w-1/2">{payment.payment.user.affiliateProgramBrandName}</span>{payment.orderItem.pricePlan ? "/" : ""}</>}{payment.orderItem.pricePlan && <PricePlanTooltip pricePlan={payment.orderItem.pricePlan} hiddenInfo={true}><span className="truncate">{payment.orderItem.pricePlan.name}</span></PricePlanTooltip>}</div><span className="truncate">{payment.payment.customer.email}</span></div></div>{payment.isFirstPayment && <Tooltip mode="hover" label={t("dashboard.affiliate.first_payment")}><NotificationIcon /></Tooltip>}</div>;
    $[18] = setMainFilter;
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = {
      key: "paymentItem",
      widthPercent: 55,
      header: t8,
      onRender: t9
    };
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("dashboard.affiliate.commission");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== changeTag || $[27] !== t || $[28] !== user?.dashboardLocale || $[29] !== user?.dateFormat || $[30] !== user?.timeFormat || $[31] !== user?.timezone) {
    t12 = payment_0 => <div className="flex w-full items-center gap-5 truncate">{payment_0.affiliateCommission.type === AffiliateCommissionTypeEnum.first_tier && payment_0.estimatedPayoutDate ? <Tooltip mode="hover" wrapperClassName="truncate" label={<div className="text-start"><TransLoco t={t} i18nKey="dashboard.affiliate.commission_tooltip" values={{
          delay: payment_0.affiliateCommission.offer.payoutDelay,
          date: dateFormat(payment_0.estimatedPayoutDate, {
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })
        }} /></div>}><span className={`truncate ${payment_0.isFirstPayment && "text-text-primary font-bold"}`}>{currencyFormat(centsToUnits(cents(payment_0.amount * (payment_0.affiliateCommission.affiliateCommission / 100))), payment_0.payment.currency, user?.dashboardLocale)}</span></Tooltip> : <span className={`${payment_0.isFirstPayment && "text-text-primary font-bold"}`}>{currencyFormat(centsToUnits(cents(payment_0.amount * (payment_0.affiliateCommission.affiliateCommission / 100))), payment_0.payment.currency, user?.dashboardLocale)}</span>}<div className="flex items-center gap-1.5">{payment_0.payment.refundedAt && <Tooltip mode="hover" label={`${t("global.refunded")} (${dateTimeFormat(payment_0.payment.refundedAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })})`}><RefundIcon className="fill-orange h-[20px] w-[20px]" /></Tooltip>}{payment_0.affiliateCommission.cancelledAt && <Tooltip mode="hover" label={t("dashboard.affiliate.commission_revoked")}><ExclamationIcon className="fill-danger h-[20px] w-[20px]" /></Tooltip>}{payment_0.payment.pending && <Tooltip mode="hover" label={t("dashboard.affiliate.pending")}><TimeIcon className="fill-orange h-[20px] w-[20px]" /></Tooltip>}{payment_0.affiliateCommission.type === AffiliateCommissionTypeEnum.next_gen && <Tooltip popoverClassName="max-w-[250px] lg:max-w-[450px]" mode="hover" label={t("dashboard.affiliate.next_gen_commission")}><CommissionNextGenIcon /></Tooltip>}{payment_0.affiliateCommission.type === AffiliateCommissionTypeEnum.second_tier && <Tooltip mode="hover" label={t("dashboard.affiliate.second_tier_commission")}><CommissionSecondTierIcon /></Tooltip>}</div>{payment_0.payment.customer.affiliateTag && <button onClick={() => payment_0.payment.customer.affiliateTag && changeTag(payment_0.payment.customer.affiliateTag.id)} className="ring-brand-primary bg-background-primary text-text-primary h-fit w-fit truncate rounded-lg px-2 py-1 outline-hidden ring-offset-2 focus-visible:ring-2">{payment_0.payment.customer.affiliateTag.name}</button>}</div>;
    $[26] = changeTag;
    $[27] = t;
    $[28] = user?.dashboardLocale;
    $[29] = user?.dateFormat;
    $[30] = user?.timeFormat;
    $[31] = user?.timezone;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12) {
    t13 = {
      key: "paymentItem",
      widthPercent: 30,
      header: t11,
      onRender: t12
    };
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t) {
    t14 = t("global.date");
    $[36] = t;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== user?.dateFormat || $[39] !== user?.timeFormat || $[40] !== user?.timezone) {
    t15 = payment_1 => <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(payment_1.payment.paidAt, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className={`w-full truncate ${payment_1.isFirstPayment && "text-text-primary font-bold"}`}>{dateFormat(payment_1.payment.paidAt, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[38] = user?.dateFormat;
    $[39] = user?.timeFormat;
    $[40] = user?.timezone;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t14 || $[43] !== t15) {
    t16 = {
      key: "paymentItem",
      widthPercent: 15,
      header: t14,
      onRender: t15
    };
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t10 || $[46] !== t13 || $[47] !== t16) {
    t17 = [t10, t13, t16];
    $[45] = t10;
    $[46] = t13;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  const columns = t17;
  let t18;
  if ($[49] !== t) {
    t18 = t("dashboard.affiliate.payments");
    $[49] = t;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t) {
    t19 = t("dashboard.affiliate_dashboard.any_tag");
    $[51] = t;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = data => setFilterWithTag(prev_2 => ({
      ...prev_2,
      affiliateTag: data
    }));
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== filterWithTag.affiliateTag || $[55] !== t19 || $[56] !== tagsData) {
    t21 = <FormSelect placeholder={t19} value={filterWithTag.affiliateTag} data={tagsData} onChange={t20} />;
    $[54] = filterWithTag.affiliateTag;
    $[55] = t19;
    $[56] = tagsData;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== limit || $[59] !== setLimit) {
    t22 = {
      limit,
      setLimit
    };
    $[58] = limit;
    $[59] = setLimit;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  let t23;
  if ($[61] !== pagination || $[62] !== setPagination) {
    t23 = {
      pagination,
      setPagination
    };
    $[61] = pagination;
    $[62] = setPagination;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== affiliatePayments || $[65] !== columns || $[66] !== t22 || $[67] !== t23) {
    t24 = <Table data={affiliatePayments} columns={columns} limiter={t22} paginator={t23} />;
    $[64] = affiliatePayments;
    $[65] = columns;
    $[66] = t22;
    $[67] = t23;
    $[68] = t24;
  } else {
    t24 = $[68];
  }
  let t25;
  if ($[69] !== affiliatePayments || $[70] !== counter || $[71] !== t18 || $[72] !== t21 || $[73] !== t24) {
    t25 = <ListingLayout data={affiliatePayments} title={t18} type="compact" counter={counter} customHeaderElement={t21}>{t24}</ListingLayout>;
    $[69] = affiliatePayments;
    $[70] = counter;
    $[71] = t18;
    $[72] = t21;
    $[73] = t24;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  return t25;
};
export default AffiliateDashboardPayments;